import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface StreamingConfirmationOptions {
  title: string;
  message: string;
  confirmText: string;
  cancelText: string;
}

@Component({
  selector: 'app-streaming-confirmation-popup',
  templateUrl: './streaming-confirmation-popup.component.html',
  styleUrls: ['./streaming-confirmation-popup.component.scss']
})
export class StreamingConfirmationPopupComponent {
  @Input() show: boolean = false;
  @Input() options: StreamingConfirmationOptions = {
    title: 'Response in Progress',
    message: 'A response is currently being generated. Switching sessions will stop the current response. Do you want to continue?',
    confirmText: 'Continue',
    cancelText: 'Cancel'
  };

  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  onConfirm(): void {
    this.confirm.emit();
  }

  onCancel(): void {
    this.cancel.emit();
  }
}
